const ActionButtonsBarComponent = {
    templateUrl: '/ui/actionButtonsBar/actionButtonsBar.tpl.html',
    controller: 'actionButtonsBarController',
    bindings: {
        context: '<',
        actions: '<',
        hiddenInputActions: '<?',
        actionSubTexts: '<?',
        hideDropdown: '<?',
        notifyActionClicked: '&',
        timeLastModified: '<'
    }
};

angular.module('umCore')
    .component('actionButtonsBar', ActionButtonsBarComponent);
